import './signin.css'
import React from 'react'
import logo from '../../assets/images/logo_2.png'
import qoute from '../../assets/images/quote2.png'
import truck from '../../assets/images/truck.png'
import { Link, useHistory } from 'react-router-dom'

function SignIn() {
    const history = useHistory()
    return (
        <div className='sign-parent'>
            <div className='sign-logo'>
                <img src={logo} alt="" />
            </div>
            <div className='sign-cont'>
                <div className='sign-truck'>
                    <img src={truck} alt="" />
                </div>
                <div className='sign-form'>
                    <form>
                        <div className=' load-form'>
                            <h3>Login</h3>
                            <p>Lorem Ipsum is simply text</p>
                            <div className=' load-input-wrapper'>
                                <div className=' load-input'>
                                    <label>Email</label>
                                    <input required type={'email'} placeholder="Enter email" className='form-input_ input' />
                                </div>
                                <div className=' load-input'>
                                    <label>Password</label>
                                    <input required type={'password'} placeholder="Enter password" className='form-input_' />
                                </div>
                            </div>
                            <div className='sign-forget'>
                                <a href="#">Forgot Password?</a>
                            </div>
                            <div className='form-buttons'>
                                <button onClick={() => {
                                    history.push('/')
                                    sessionStorage.setItem('authData', 'auth')
                                }} style={{ fontSize: '14px' }} className='button-primary'>Login</button>
                            </div>
                            <div className='sign-form-bottom'>
                                <p>Don’t have an account? <Link to="/sign-up">Sign Up</Link></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='sign-footer'>
                <img src={qoute} alt="" />
            </div>
        </div>
    )
}

export default SignIn